<template>
  <a-badge :status="status" :text="text"></a-badge>
</template>

<script>
export default {
  name: 'CollectStateTag',
  props: {
    state: { type: Number, default: 0 }
  },
  data () {
    return { status: 'default', text: '' }
  },
  mounted () {
    switch (this.state) {
      case 2:
        this.status = 'success'
        this.text = '已收集'
        break
      case 1:
        this.status = 'processing'
        this.text = '收集中'
        break
      default:
        this.status = 'default'
        this.text = '未收集'
        break
    }
  }
}
</script>
